import { MARKET_PLACE_VIEW } from '@/utils/permissions'

export default [
  {
    path: '/marketplace',
    name: 'marketlist',
    component: () => import('@/views/marketplace/MarketPlace.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Marketplace',
      permissions: [MARKET_PLACE_VIEW]
    }
  },
  {
    path: '/marketplace/seller_product/:id',
    name: 'marketlist-view-sellerProducts',
    component: () => import('@/views/marketplace/MarketPlace.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Marketplace',
      permissions: [MARKET_PLACE_VIEW]
    }
  },
  {
    path: '/marketplace/product/:id',
    name: 'marketlist-view-product',
    component: () => import('@/views/marketplace/MarkertPlaceViewProduct.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Marketplace',
      permissions: [MARKET_PLACE_VIEW]
    }
  }
]